import DataTable from "components/data-table/data-table";
import { TableColumn } from "components/table/table";
import { addItem, apply, currencyFormat, removeItem } from "core/utils";
import set from "lodash/set";
import { useEffect, useRef, useState } from "react";
import { ActionHandler, ObjectIndex } from "types";
import { PrimaryButton } from "../../../../components/buttons/buttons";
import { PagoPendienteRespuesta } from "../types/pagos.types";

const getColumnsDefinition = (customHeader: React.ReactNode): TableColumn[] => [
	{ key: "seleccionar", title: "", customHeaderElement: customHeader },
	{ key: "referencia", title: "Referencia de Pago", tdStyle: { width: 190, wordBreak: "break-all" } },
	{ key: "idCobro", title: "ID de Cobro", tdStyle: { width: 190, wordBreak: "break-all" } },
	{ key: "concepto", title: "Concepto de Pago" },
	{ key: "importe", title: "Importe", tdStyle: { textAlign: "right" } },
	{ key: "estatus", title: "Estatus de Pago" },
	{ key: "fechaSolicitud", title: "Fecha de Solicitud de Pago" },
	{ key: "vigenciaPago", title: "Vigencia de Pago" },
	{ key: "acciones", title: "", tdStyle: { width: 180 } }
];

type PagosPendientesTableProps = {
	loading?: boolean;
	pagar: ActionHandler<PagoPendienteRespuesta>;
	registros: PagoPendienteRespuesta[];
	onSelectionChanged?: ActionHandler<PagoPendienteRespuesta[]>;
};

const PagosPendientesTable = ({ loading, registros, pagar, onSelectionChanged }: PagosPendientesTableProps) => {
	const [selectedItems, setSelectedItems] = useState<PagoPendienteRespuesta[]>([]);
	const headerRef = useRef<HTMLInputElement>(null);

	const checkedItemHandler = (item: PagoPendienteRespuesta) => (e: React.ChangeEvent<HTMLInputElement>) => {
		const op = e.target.checked ? addItem : removeItem;
		setSelectedItems(state => op(state, item));
	};

	const checkedHeaderHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const selectedItems = e.target.checked ? [...registros] : [];
		setSelectedItems(selectedItems);
	};

	const checkboxHeaderItem = (
		<input
			ref={headerRef}
			className="form-check-input"
			onChange={checkedHeaderHandler}
			type="checkbox"
		/>
	);

	const mostrarAcciones = (column: TableColumn, registro: PagoPendienteRespuesta & ObjectIndex) => {
		if (column.key === "seleccionar") {
			return (
				<input
					className="form-check-input"
					onChange={checkedItemHandler(registro)}
					checked={selectedItems.includes(registro)}
					type="checkbox"
				/>
			);
		}

		if (column.key === "acciones" && registro.estatus === "Pendiente") {
			return (
				<div className="acciones">
					<PrimaryButton disabled={loading} onClick={apply(pagar, registro)}>Pagar</PrimaryButton>
				</div>
			);
		}

		if (column.key === "importe") {
			return currencyFormat(registro[column.key]);
		}

		return registro[column.key];
	};

	useEffect(() => {
		const allSelected = registros.length > 0 && registros.length === selectedItems.length;
		set(headerRef, "current.checked", allSelected);
	}, [registros, selectedItems, onSelectionChanged]);

	useEffect(() => {
		onSelectionChanged?.(selectedItems);
	}, [selectedItems, onSelectionChanged]);

	return (
		<DataTable
			columns={getColumnsDefinition(checkboxHeaderItem)}
			items={registros}
			onRenderItem={mostrarAcciones}
		/>
	);
};

export default PagosPendientesTable;